<!--tristate funktioniert hier noch nicht-->
<!--<p-triStateCheckbox #tricheckbox [disabled]="disabled" [style.display]="nullable ? 'inline' : 'none'" [(ngModel)]="value" label="{{label}}"
 (onChange)="handleCRUDItemChange($event)">
</p-triStateCheckbox>-->

<!-- da tristate noch nicht funktioniert: bei der checkbox die condition entfertn: [style.display]="!nullable ? 'inline' : 'none'"-->
<p-checkbox #checkbox [disabled]="disabled" binary="true" [(ngModel)]="value" (onChange)="handleCRUDItemChange($event)"></p-checkbox><!--label="{{label}}"-->
&nbsp;<label>{{label}}</label>

